import { BasicLayout } from '../../modules/Layouts/basicLayout'
import { State } from '../../reducers';
import { useDispatch, useSelector } from 'react-redux';

import ModalsControl from './Components/ModalsControl';
import { ViewFactura } from './Components/VisualizacionFactura/ViewFactura';
import { FooterView } from './Components/VisualizacionFactura/FooterView';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import BasicHeaderDocumentos from '../OtrosDocumentos/Components/BasicHeader';

const VisualizacionFactura = () => {
  const {activeFactura} = useSelector((state: State) => state.historial);
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos);
  const history = useHistory();

  useEffect(() => {
    if (!activeFactura) {
      history.push("/history-invoice?reload=0");
    }
  }, []);

  return (
    <BasicLayout>
      {
        (activeFactura) && 
        (
          <>
            <ModalsControl />
            <BasicHeaderDocumentos 
              title={'Detalle de ' + tipoDocumentosEmision.find((dte) => dte.codigodocumento === activeFactura?.DetallesDTE?.identificacion?.tipoDte)?.nombre} 
              url="/history-invoice?reload=0" 
            />
            <ViewFactura />
            <FooterView />
          </>
        )
      }
    </BasicLayout>
  )
}

export default VisualizacionFactura;
